import React, { useState, useEffect } from "react";
import { Table, Transfer, Form, Input, Button } from "antd";
import { difference } from "lodash";
import { EditableCell, EditableRow } from "../TableEditAble";

const TableTransfer = ({ leftColumns, rightColumns, ...restProps }) => {
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  return (
    <Transfer {...restProps}>
      {({
        direction,
        filteredItems,
        onItemSelectAll,
        onItemSelect,
        selectedKeys: listSelectedKeys,
        disabled: listDisabled,
      }) => {
        const columns = direction === "left" ? leftColumns : rightColumns;
        const rowSelection = {
          getCheckboxProps: (item) => ({
            disabled: listDisabled || item.disabled,
          }),
          onSelectAll(selected, selectedRows) {
            const treeSelectedKeys = selectedRows
              .filter((item) => !item.disabled)
              .map(({ key }) => key);
            const diffKeys = selected
              ? difference(treeSelectedKeys, listSelectedKeys)
              : difference(listSelectedKeys, treeSelectedKeys);
            onItemSelectAll(diffKeys, selected);
          },
          onSelect({ key }, selected) {
            onItemSelect(key, selected);
          },
          selectedRowKeys: listSelectedKeys,
        };
        return (
          <Table
            rowSelection={rowSelection}
            columns={columns}
            components={components}
            dataSource={filteredItems}
            size="small"
            rowClassName={() => "editable-row"}
            pagination={false}
            style={{
              pointerEvents: listDisabled ? "none" : undefined,
            }}
          />
        );
      }}
    </Transfer>
  );
};

const StoreFood = (props) => {
  const [targetKeys, setTargetKeys] = useState([]);
  const [data, setData] = useState([]);
  const onChange = (nextTargetKeys) => {
    setTargetKeys((prev) => {
      if (prev.length > nextTargetKeys.length) {
        var array3 = prev.filter(function (obj) {
          return nextTargetKeys.indexOf(obj) == -1;
        });
        if (array3 && array3.length > 0) {
          array3.map((item) => {
            let res = data.find((x) => x.id === item);
            if (res) {
              delete res.qty;
              handleSave(res);
            }
          });
        }
      }
      return nextTargetKeys;
    });
  };

  useEffect(() => {
    if (props.editData && Object.keys(props.editData).length) {
      props
        .request({ url: `/product/list`, method: "POST", body: {} })
        .then((res) => {
          if (res.success) {
            res.data.map((item, i) => {
              item.key = item.id;
            });

            props
              .request({ url: `/product/firstqty/list/${props.editData.id}` })
              .then((res1) => {
                if (res1.success) {
                  if (res1.data) {
                    let newKeys = [];
                    res1.data.map((item) => {
                      newKeys.push(item.productid);
                      let finded = res.data.find(
                        (x) => x.id === item.productid
                      );
                      if (finded) {
                        finded.qty = item.qty;
                      }
                    });
                    setTargetKeys(newKeys);
                    setData(res.data);
                  }
                }
              });
          }
        });

      props.form.setFieldsValue({ newid: props.editData.id });
    }
  }, [props.editData]);

  const handleSave = (row) => {
    const newData = [...data];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };

  useEffect(() => {
    props.form.setFieldsValue({ jsondata: JSON.stringify(data) });
  }, [data]);

  const excelExportData = [
    {
      "Барааны нэр": "Цамц",
      "Тоо хэмжээ": "100",
    },
  ];

  return (
    <div className="mb-5">
      <TableTransfer
        dataSource={data}
        targetKeys={targetKeys}
        disabled={false}
        showSearch={true}
        onChange={onChange}
        filterOption={(inputValue, item) =>
          item.name.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
        }
        leftColumns={props.columns}
        rightColumns={[
          ...props.columns,
          {
            title: "Тоо хэмжээ",
            dataIndex: "qty",
            key: "qty",
            align: "center",
            editable: true,
            onCell: (record) => ({
              record,
              editable: true,
              dataIndex: "qty",
              title: "Тоо хэмжээ",
              handleSave,
            }),
          },
        ]}
      />
      <Form.Item name={`jsondata`} hidden>
        <Input />
      </Form.Item>
      <Form.Item name={`newid`} hidden>
        <Input />
      </Form.Item>
    </div>
  );
};

export default StoreFood;
